var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    [
      _vm.title
        ? _c("b-row", [_c("b-col", [_c("h3", [_vm._v(_vm._s(_vm.title))])])], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c(
            "b-row",
            [
              _c("b-col", {
                staticClass: "description",
                domProps: { innerHTML: _vm._s(_vm.description) },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("sp-feature-highlights", {
                attrs: {
                  highlights: _vm.highlights,
                  "highlights-layout": _vm.highlightsLayout,
                  "highlights-style": _vm.highlightsStyle,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }